<template>
  <span class="gam-icon-text">
    <template v-for="(part, index) in parts" :key="index">
      <span v-if="part.icon" class="gam-icon-text__icon">
        <GamIcon :name="part.icon" size="1.15em" is-current />
      </span>
      <strong v-else-if="part.bold">{{ part.text }}</strong>
      <template v-else>{{ part.text }}</template>
    </template>
  </span>
</template>

<script lang="ts" setup>
import GamIcon from '@/views/components/GamIcon.vue';
import { GamIconName } from '@/views/composables/constants/components/gamIcon.constants';
import { computed } from 'vue';

interface IconTextPart {
  text: string;
  icon?: GamIconName;
  bold?: boolean;
}

// Translations write browser buttons as {token} and labels as **label**.
const ICON_TOKENS: Record<string, GamIconName> = {
  page_menu: GamIconName.PAGE_MENU,
  aa: GamIconName.TEXT_SIZE,
  tune: GamIconName.TUNE,
  lock: GamIconName.LOCK,
  dots: GamIconName.DOTS_H,
  menu: GamIconName.HAMBURGER,
};

const TOKEN_PATTERN = /(\{[a-z_]+\}|\*\*[^*]+\*\*)/g;

const props = defineProps<{ text: string }>();

const parts = computed<IconTextPart[]>(() =>
  props.text
    .split(TOKEN_PATTERN)
    .filter(Boolean)
    .map((chunk) => {
      if (chunk.startsWith('**') && chunk.endsWith('**')) {
        return { text: chunk.slice(2, -2), bold: true };
      }
      const icon = chunk.startsWith('{') ? ICON_TOKENS[chunk.slice(1, -1)] : undefined;
      return icon ? { text: chunk, icon } : { text: chunk };
    }),
);
</script>

<style lang="scss" scoped>
.gam-icon-text strong {
  color: var(--color-white);
  font-weight: 600;
}

.gam-icon-text__icon {
  display: inline-flex;
  vertical-align: -0.2em;
  padding: 0.1em 0.3em;
  margin: 0 0.1em;
  border-radius: 0.4em;
  background: var(--color-white-10);
  color: var(--color-white);
}
</style>
